import { useCallback, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { shareContext } from '../../ShareContext';
import { FilledButton } from 'components';
import useStyles from './AddDocumentButton.styles';
import useSmallDesktopScreen from 'hooks/useSmallDesktopScreen';
import MobileExplorerToolbarMenuItemButton from 'mobile/App/Share/ExplorerToolbar/MobileExplorerToolbarMenuItemButton';

const AddDocumentButton = (): JSX.Element | null => {
  const classes = useStyles();
  const { dropzoneState } = useContext(shareContext);
  const isSmallScreen = useSmallDesktopScreen();
  const handleAddDocument = useCallback(
    () => dropzoneState?.open(),
    [dropzoneState],
  );

  if (!dropzoneState) {
    return null;
  }

  if (isSmallScreen) {
    return (
      <MobileExplorerToolbarMenuItemButton
        messageId="share.document.add.button"
        onClick={handleAddDocument}
      />
    );
  }

  return (
    <FilledButton
      className={classes.button}
      color="violet"
      data-testid="add-document-button"
      onClick={handleAddDocument}
    >
      <FormattedMessage id="share.document.add.button" />
    </FilledButton>
  );
};

export default AddDocumentButton;
